// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"xWegB","item":"_3XUMg","isMobile":"_3egjz","icon":"_1f-Ar"};